module.exports = __webpack_public_path__ + "img/finance-icon-2.3de890f9.svg";